<template>
  <section>
    <section v-show="isShow" class="menus-left" id="menu" ref="menu">
      <menu v-for="menu in menus" :key="`menu${menu.label}`">
        <details :open="menu.open" @toggle="toggleMenu(menu, $event)">
          <summary :class="`menus-title${currentRouteTopPath === menu.path ? ' active-menu' : ''}`">
            <template v-if="menu.children">
              {{ menu.label }}
              <i class="icon-b-arrow"></i>
              <v-icon :name="menu.icon"/>
            </template>

            <router-link v-else :to="menu.path" class="menu-single-link">
              {{ menu.label }}
              <v-icon :name="menu.icon"/>
            </router-link>
          </summary>
        </details>

        <ul v-if="menu.children" :class="`menus menus-${menu.children.length}`">
          <li
              v-for="item in menu.children"
              :key="`menuChildren${item.label}`"
              :class="`${currentRouteName === item.name ? 'menu-item-active' : ''}`"
          >
            <router-link :to="item.to()">
              <i class="icon-r-arrow"></i>
              {{ item.label }}
            </router-link>
          </li>
        </ul>
      </menu>
    </section>
    <section v-show="isMobile && isShow" class="menu-mask" @click="isShow = false"></section>
    <v-icon v-if="isMobile" class="menu-icon-box flex-center" name="menu" @click="isShow = true"/>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';

const allRoutes =  Object.values(RouteConfig);
const initMenus = allRoutes[0];

let openedMenus = {};
const openedMenuKey = 'OPENED-MENUS';

try {// 尝试获取storage里的菜单信息
  openedMenus = JSON.parse(window.localStorage.getItem(openedMenuKey));
} catch (e) {// 获取不到不做处理
}
openedMenus = openedMenus || {};

export default {
  data: () => ({
    menus: [],
    RouteConfig,
    openedMenus,
    isShow: true,
    mutationObserver: null,
  }),
  methods: {
    resetHeight() {
      const menu = this.$refs.menu;
      if (!menu) return;

      const minHeight = window.innerHeight - 190;
      menu.style.height = `${minHeight}px`;
    },
    toggleMenu(menu, event) {
      if (!menu.children || !event || !event.target) return;

      const nextOpen = !!event.target.open;
      menu.open = nextOpen;
      openedMenus[menu.icon] = nextOpen;
      localStorage.setItem(openedMenuKey, JSON.stringify(openedMenus));
    },
    generateMenus() {
      const { userRole } = this;
      let moreMenus = [];
      const values = allRoutes.slice(2);
      const tempOpenedMenus = this.openedMenus;

      values.forEach(item => {
        if (item.hidden || item.path.split('/').length !== 2 || !item.role.includes(userRole)) return;

        // 被 / 分割为两个元素的视为菜单栏父级列表
        let children = [];
        for (let value of values) {
          if (value.hidden) continue;

          const isChild = value.path.startsWith(item.path);
          // 收集全部同前缀子栏目：路由配置里栏目分组不一定连续（例如“舞者等级活动”
          // 插在学员子栏目中间），遇到第一个非子栏目不能 break，否则后续子栏目会丢失
          if (isChild && value.role.includes(userRole)) children.push(value);
        }

        const icon = item.path.slice(1);
        moreMenus.push({
          label: item.label.replace('列表', ''),
          path: item.path,
          icon,
          open: tempOpenedMenus[icon] === undefined ? item.open : tempOpenedMenus[icon],
          children,
        });
      });
      this.menus = [initMenus, ...moreMenus];
    }
  },
  watch: {
    userRole() {
      this.generateMenus();
    },
    '$route'() {
      if (this.isMobile) return this.isShow = false;
      this.resetHeight();
    },
  },
  computed: {
    userRole() {
      return this.$store.getters.userRole;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    currentRouteName() {
      return this.$route.name;
    },
    currentRouteTopPath() {
      return `/${this.$route.path.split('/', 2)[1]}`;
    },
  },
  created() {
    this.generateMenus();
    if (this.isMobile) this.isShow = false;
  },
  mounted() {
    if (this.isMobile) return;

    const appElement = document.getElementById('app');

    this.mutationObserver = new MutationObserver(() => {
      const menu = this.$refs.menu;
      if (!menu) return;

      const minHeight = window.innerHeight - 190;
      menu.style.height = `${minHeight}px`;

      const formListHeight = appElement.offsetHeight - 180;
      menu.style.height = formListHeight > minHeight ? `${formListHeight}px` : `${minHeight}px`;
    });
    this.mutationObserver.observe(appElement, { childList: true, subtree: true });
  },
  beforeDestroy() {
    if (this.isMobile || !this.mutationObserver) return;
    this.mutationObserver.disconnect();
  },
};
</script>

<style src="./menu.css"></style>
<style src="./menu-phone.css"></style>
